'use client';

import { PropsWithChildren } from 'react';
import { IconClose, IconTick } from '@/components/svg-symbols/icons';
import { cn } from '@/utils/cn';
interface Props extends PropsWithChildren {
  name: string;
  customOnChange?: (state: boolean) => void;
  className?: string;
  size: 'large' | 'medium';
  disabled?: boolean;
  isChecked?: boolean;
}
export function Switch({
  children,
  name,
  customOnChange,
  className,
  size,
  disabled,
  isChecked
}: Props) {
  const onChangeStatus = (checked: boolean) => {
    customOnChange && customOnChange(checked);
  };
  return <label className={cn('relative flex w-fit cursor-pointer flex-row items-center justify-between gap-2', className)} data-sentry-component="Switch" data-sentry-source-file="switch.tsx">
            {typeof children === 'string' ? <span className='text-body-14 text-text-black lg:text-body-16'>{children}</span> : children}
            <div className={cn('relative box-content px-px', {
      'h-4 w-9.5': size === 'large',
      'h-3 w-7.5': size !== 'large'
    })}>
                <input type='checkbox' onChange={e => onChangeStatus(e.target.checked)} name={name} className='peer hidden' disabled={disabled} {...isChecked !== undefined ? {
        checked: isChecked
      } : {}} />

                <span className={cn('absolute -top-0.5 left-0 box-content flex items-center justify-center rounded-full bg-gray-100 text-gray-300 shadow-sm transition-all duration-500 ease-in-out peer-checked:text-primary-main peer-disabled:peer-checked:text-primary-shade-300', 'peer-disabled:text-gray-200 peer-checked:[&>.close]:hidden peer-checked:[&>.tick]:flex', {
        'h-5 w-5 peer-checked:left-5': size === 'large',
        'h-4 w-4 peer-checked:left-4': size !== 'large'
      })}>
                    <IconTick className='tick hidden h-4 w-4' data-sentry-element="IconTick" data-sentry-source-file="switch.tsx" />
                    <IconClose className={cn('close', {
          'h-4 w-4': size === 'large',
          'h-3 w-3': size !== 'large'
        })} data-sentry-element="IconClose" data-sentry-source-file="switch.tsx" />
                </span>

                <span className='block h-full w-full overflow-hidden rounded-full bg-gray-300 transition-all duration-500 ease-in-out peer-checked:bg-primary-main peer-disabled:bg-gray-200 peer-disabled:peer-checked:bg-primary-shade-300' />
            </div>
        </label>;
}